export const environment = {
  production: false,
  keycloak: {
    url: 'https://keycloak.zupit.software',
    realm: 'code-quality-staging',
    clientId: 'codequality-web',
  },
  api: {
    baseUrl: 'https://code-quality-api.staging.zupit.software',
  },
};
